import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";
import { Link } from "react-router-dom";
import { AlertCircle } from "react-feather";


function HotelRoomList({hotelMarkup}) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hotelToken = queryParams.get("hotelToken");

  const [hotelData, setHotelData] = useState(null);

  const [showModal, setShowModal] = useState(false); 
  const [showModalame, setShowModalame] = useState(false);

  console.log("hotelMarkup",hotelMarkup);

  useEffect(() => {
    if (hotelToken) {
      axios
        .post(`${baseurl}hotelrooms`, { hotelToken })
        .then((response) => {
          console.log("API Response:", response.data);

          // Extract hotel rooms data correctly
          const hotelInfo =
            response.data?.RoomList?.GetHotelRoomResult?.HotelRoomsDetails;

          if (hotelInfo) {
            setHotelData(hotelInfo);
          } else {
            console.warn("No hotel room data found.");
          }
        })
        .catch((error) => {
          console.error("Error fetching hotel details:", error);
        });
    }
  }, [hotelToken]);

  return (
    <>
      <div className="container py-4">
        {hotelData && hotelData.length > 0 ? (
          <div className="row">
            <div className="sum1 w100 p-3 text-white text-center bg-white">
              <div className="text-center">Rooms Available</div>
            </div>

            {hotelData.map((room, index) => (
              <div key={index} className="border rounded mb-2">
                <div className="row p-3 bg-white">
                  <div className="col-md-9 text-start">
                    <div className="roomnm">
                    {room.RoomTypeName || "Room Name Not Available"}
                    </div>

                    <hr/>

<div>
<div className="kma">Smoking : {room.SmokingPreference || "No Preference"}  </div>

{room?.Amenities?.length > 0 && (
        <div>
          <div
            onClick={() => setShowModalame(true)}
            style={{ cursor: "pointer" }}
            className="iZHNjh"
          >
            Amenity Available <AlertCircle size={15}/>
          </div>

          {showModalame && (
            <div className="modal-overlay" onClick={() => setShowModalame(false)}>
              <div className="modal-content one11" onClick={(e) => e.stopPropagation()}>
                <div className="kma">Amenities</div>
                <ul className="row">
                  {room.Amenities.map((amenity, index) => (
                    <li className="col-md-6 text-start kma" key={index}>
                      {amenity}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      )}




 
<div onClick={() => setShowModal(true)} style={{ cursor: "pointer" }} className="iZHNjh">
        Cancellation Policy <AlertCircle size={15}/>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content one11">
          <div className="kma1 text-start mb-2">Cancellation Policy:</div>
<ul className="kma">
  {room?.CancellationPolicy?.split(" | ")
    .map(policy => policy.trim()) // Remove extra spaces
    .filter(policy => policy.length > 0) // Ensure only non-empty policies are printed
    .map((policy, index) => (
      <li key={index} className="kma text-start">{index + 1}. {policy}</li>
  ))}
</ul>



            {/* <div>
  {room?.CancellationPolicies?.length > 0 ? (
    room.CancellationPolicies.map((policy, index) => (
      <div key={index}>
        {policy.Charge === 0 ? (
          <>Free cancellation till {policy.ToDate}</>
        ) : (
          <>
            {policy.Currency === "INR" ? "₹" : policy.Currency} {policy.Charge}
          </>
        )}
      </div>
    ))
  ) : (
    <div>No cancellation policies available</div>
  )}
</div> */}

          </div>
        </div>
      )}

  </div>   
            
                  </div> 
                  <div className="col-md-3 text-start">
                    <div className="d-flex">
                      <span className="discount">
                        {room?.Price?.PublishedPriceRoundedOff &&
                        room?.Price?.OfferedPriceRoundedOff
                          ? `${Math.round(
                              ((room.Price.PublishedPriceRoundedOff -
                                room.Price.OfferedPriceRoundedOff) /
                                room.Price.PublishedPriceRoundedOff) *
                                100
                            )}% Off`
                          : ""}
                      </span>
                      <span className="eVznBG"></span>
                    </div>
                    <div className="pubprice">
                    {room?.Price?.CurrencyCode === "INR"
                        ? "₹"
                        : room?.Price?.CurrencyCode}
                      {/* {room?.Price?.PublishedPriceRoundedOff} */}

                      {(Number(room?.Price?.PublishedPriceRoundedOff) || 0) + hotelMarkup}
                    </div>

                    <div className="offerprice">
                      {room?.Price?.CurrencyCode === "INR"
                        ? "₹"
                        : room?.Price?.CurrencyCode}

                      {/* {room?.Price?.OfferedPriceRoundedOff} */}

                      {(Number(room?.Price?.OfferedPriceRoundedOff) || 0) + hotelMarkup}
                    </div>


                    <div className="taxfee">
                      - {" "}
                      {room?.Price?.CurrencyCode === "INR"
                        ? "₹"
                        : room?.Price?.CurrencyCode}{" "}

{(Number((room?.Price?.Tax || 0) + (room?.Price?.ServiceTax || 0) + (room?.Price?.GST || 0)) || 0) + hotelMarkup}


                      {/* {(room?.Price?.Tax || 0) +
                        (room?.Price?.ServiceTax || 0) +
                        (room?.Price?.GST || 0)}{" "} */}
                      &nbsp;taxes & fees Included
                    </div>
                    <div className="prnght"> </div>

                    <div className="mb-2">
                      <Link to={`/book-room?ResultToken=${hotelToken}&RoomUniqueId=${room.RoomUniqueId}`} className="fhJGsp">Book Now</Link>
                    </div>
                  </div>
                </div>

             
              </div>
            ))}
          </div>
        ) : (
          <p></p>
        )}
      </div>
    </>
  );
}

export default HotelRoomList;
